import React from "preact-compat";
import {useState} from "preact/hooks";

export default ({ posts = []}) => {
    const [count, setCount] = useState(posts.length > 3 ? posts.length > 6 ? 9 : 6 : 3);

    const getImagesBlock = (countOfImages) => {
        let images = [];
        for (let i = 0; i < countOfImages; i++) {
            if (posts[i] && posts[i].thumbnail) {
                images.push(
                    <div className="image"><img src={posts[i].thumbnail} alt="Post Image"/></div>
                )
            } else if (!posts[i]) {
                images.push(<div className="image"><img src="/assets/images/img-placeholder.png" alt="Post Image"/></div>)
            }
        }
        if (posts.length > countOfImages) {
            images[count - 1] = <div className="image">
                <img src={posts[countOfImages].thumbnail} alt="Post Image"/>
                <button onClick={() => setCount(count + 3)} className="btn-more">See<br/>more</button>
            </div>
        }
        return images;
    }

    // <div className="images-column">
    //     <div className="portfolio-images">
    //         <h2>Portfolio</h2>
    //         <div className="images-list">
    //             <div className="image"><img src="images/img1-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img2-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img3-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img4-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img5-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img6-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img7-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image"><img src="images/img8-portfolio-dsk.png" alt="image description"/>
    //             </div>
    //             <div className="image">
    //                 <img src="images/img8-portfolio-dsk.png" alt="image description"/>
    //                 <button className="btn-more">See<br/>more</button>
    //             </div>
    //         </div>
    //     </div>
    //
    // </div>
    return (
        <div className="images-column">
        <div className="portfolio-images">
            {posts.length && <h2>Portfolio</h2>}
            {posts.length && <div className="images-list">
                {getImagesBlock(count)}
            </div>}
        </div>
        </div>
    )
}